// Internal modules
import { appStore } from '@/store';
import { apolloClient } from '@/lib/apollo';
import { features, resolveFeatures } from '@/lib/features';
import { getGlobals, getToken, updateExperiments } from '@/lib/globals';
import INITIAL_DATA_QUERY from '@/initialDataQuery.graphql';

export const queryInitialData = ({ countryCode, languageCode }) => {
  const { fundingSource } = window.xprops || {};
  const variables = {
    countryCode,
    countryCodeAsString: countryCode,
    fundingSource,
    languageCode,
    token: getToken(),
  };

  return apolloClient
    .query({
      context: {
        isBatchedQuery: true,
      },
      query: INITIAL_DATA_QUERY,
      variables,
    })
    .then(({ data }) => {
      /**
       * @TO_DO @APOLLO_MIGRATION
       * We should be able to remove this after we migrate the store to Apollo
       * since we can read the data right from the store where it is needed.
       */
      getGlobals().initialGqlData = data;

      updateExperiments();

      features.config = resolveFeatures();

      // We don't want to hide the page spinner until all operations
      // are finished, so we reset the store with the page spinner shown.
      appStore.getActions().resetStore({ ui: { isPageLoading: true } });
    });
};
